import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

import { setSupportModalOpen } from '../../lib/support/modal/state'

export interface SupportRequestLinkProps {
  children: React.ReactNode
  className?: string
}

const SupportRequestLink: React.FC<SupportRequestLinkProps> = ({ children, className }) => {
  return (
    <ButtonLink
      className={className}
      onClick={() => {
        setSupportModalOpen(true)
      }}
    >
      {children}
    </ButtonLink>
  )
}

const StyledSupportRequestLink = styled(SupportRequestLink)`
  font-family: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
`

export default StyledSupportRequestLink
